export default __webpack_public_path__ + "staticlp1/media/istoe-dinheiro.9cd89b2e.jpg";